import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableSettings = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M1.25 2.75H4.75M17 2.75H8.25M1.25 8.875H11.75M17 8.875H15.25M1.25 15H3M17 15H6.5",
			stroke: "#979797",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 4.5C7.4665 4.5 8.25 3.7165 8.25 2.75C8.25 1.7835 7.4665 1 6.5 1C5.5335 1 4.75 1.7835 4.75 2.75C4.75 3.7165 5.5335 4.5 6.5 4.5Z",
			stroke: "#979797",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 10.625C14.4665 10.625 15.25 9.8415 15.25 8.875C15.25 7.9085 14.4665 7.125 13.5 7.125C12.5335 7.125 11.75 7.9085 11.75 8.875C11.75 9.8415 12.5335 10.625 13.5 10.625Z",
			stroke: "#979797",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.75 16.75C5.7165 16.75 6.5 15.9665 6.5 15C6.5 14.0335 5.7165 13.25 4.75 13.25C3.7835 13.25 3 14.0335 3 15C3 15.9665 3.7835 16.75 4.75 16.75Z",
			stroke: "#979797",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgTableSettings);
export { ForwardRef as ReactComponent };
